import React from 'react';
import useGetPrepaymentAuction from './hooks/useGetPrepaymentSuggestion';
import DotsLoading from 'components/loadings/dotsLoading';
import RregisteredOffersAuctionItem from './RregisteredOffersAuctionItem';
interface RregisteredOffersAuctionProps {
  postType: string;
  guid: string;
  is_saled: boolean;

  setIsOpenOfferAuction: (isOpenOffer: boolean) => void;
}
const RregisteredOffersAuction = ({
  guid,
  postType,
  is_saled,
  setIsOpenOfferAuction,
}: RregisteredOffersAuctionProps) => {
  const {data, isLoading} = useGetPrepaymentAuction(guid);

  return (
    <div className="flex flex-col w-full gap-4 pb-2">
      <div className="flex justify-between items-center text-gray-6 font-normal text-[18px]">
        <h4>پیشنهادات ثبت شده</h4>
        <button
          className="icon-close text-[15px]"
          onClick={() => setIsOpenOfferAuction(false)}
        />
      </div>
      <div className="w-full">
        <div className="flex w-full items-center justify-between py-3 text-green-1">
          <div className="pr-3 w-[10%] flex items-center justify-center" />
          <div className="text-gray-6 w-[25%] flex items-center justify-center">
            تاریخ
          </div>
          <div className="text-gray-6 w-[25%] flex items-center justify-center">
            قیمت
          </div>
          <div className="w-[20%] flex items-center justify-center" />
          <div className="w-[20%] flex items-center justify-center" />
        </div>
      </div>
      <div className="flex flex-col w-full  [&>*:nth-child(odd)]:bg-light-gray overflow-y-auto max-h-[60vh] [&>*:nth-child(even)]:bg-white">
        {isLoading ? (
          <DotsLoading />
        ) : (
          data
            ?.map((item, index) => (
              <RregisteredOffersAuctionItem
                is_saled={is_saled}
                key={index}
                img={item.profile.profile_image}
                participated_auctions={item.profile.participated_auctions}
                index={index + 1}
                price={item.price}
                created_at={item.created_at}
                guid={item.guid}
                postType={postType}
                name={item.profile.name}
                profile_type={item.profile_type}
              />
            ))
            .reverse()
        )}
      </div>
    </div>
  );
};

export default RregisteredOffersAuction;
